// Display-only reduction of the two audited equivalent Double Pack plan pairs.
// App selection, config, native plan inputs, allocations and prices stay intact.
if(!customElements.get('ark-delivery-choice-display'))customElements.define('ark-delivery-choice-display',class extends HTMLElement{
  connectedCallback(){
    if(this.abort)return;
    this.root=this.closest('.shopify-section');
    this.form=document.getElementById(this.dataset.form);
    try{this.data=JSON.parse(this.dataset.config);}catch{return;}
    if(!this.root||!this.form||String(this.data.productId)!=='14950941163864')return;
    this.abort=new AbortController();this.hiddenChoices=new Map();
    this.schedule=()=>{if(this.frame)return;this.frame=requestAnimationFrame(()=>{this.frame=0;this.render();});};
    this.observer=new MutationObserver(this.schedule);
    this.observer.observe(this.root,{childList:true,subtree:true,attributes:true,attributeFilter:['aria-selected','data-selling-plan-id','config','value']});
    this.root.addEventListener('change',this.schedule,{signal:this.abort.signal});
    this.form.addEventListener('variant:change',this.schedule,{signal:this.abort.signal});
    this.root.addEventListener('keydown',event=>this.navigateChoices(event),{capture:true,signal:this.abort.signal});
    this.render();
  }
  disconnectedCallback(){
    this.abort?.abort();this.abort=null;this.observer?.disconnect();
    if(this.frame)cancelAnimationFrame(this.frame);this.frame=0;this.restoreChoices();
  }
  restoreChoices(){
    this.hiddenChoices?.forEach((prior,node)=>{
      node.hidden=prior.hidden;
      if(prior.tabindex===null)node.removeAttribute('tabindex');else node.setAttribute('tabindex',prior.tabindex);
      if(prior.ariaHidden===null)node.removeAttribute('aria-hidden');else node.setAttribute('aria-hidden',prior.ariaHidden);
      node.removeAttribute('data-ark-c6-hidden');
    });
    this.hiddenChoices?.clear();
  }
  canonical(value){
    return JSON.stringify(value&&typeof value==='object'?this.sortValue(value):value);
  }
  sortValue(value){
    return Array.isArray(value)?value.map(item=>this.sortValue(item)):value&&typeof value==='object'?Object.fromEntries(Object.keys(value).sort().map(key=>[key,this.sortValue(value[key])])):value;
  }
  eligibleLabels(plans,configs){
    const groups=new Map(),eligible=new Map();
    plans.forEach(plan=>{const label=String(plan.name||'').trim();if(!groups.has(label))groups.set(label,[]);groups.get(label).push(plan);});
    groups.forEach((group,label)=>{
      if(!label||group.length!==2||this.displayPlans(group).length!==1)return;
      const app=group.map(plan=>configs['gid://shopify/SellingPlan/'+plan.id]);
      // Includes app-only gifts, delivery price, quantity and recurring policies.
      if(app.some(config=>!config||typeof config!=='object'||Array.isArray(config))||this.canonical(app[0])!==this.canonical(app[1]))return;
      eligible.set(label,group.length);
    });
    return eligible;
  }
  render(){
    this.restoreChoices();
    const id=String(this.form.elements.id?.value||'');
    if(id!=='54340887347544')return;
    const block=this.root.querySelector('kaching-subscriptions-block');
    let config;try{config=JSON.parse(block?.getAttribute('config')||'null');}catch{return;}
    if(String(config?.productId)!==String(this.data.productId)||!config.sellingPlanConfigs)return;
    const plans=this.data.plans,widget=block.querySelector('.kaching-subscriptions__widget');
    this.plan=widget?.getAttribute('data-selling-plan-id')||'';this.variant={id};
    if(this.plan&&!plans.some(plan=>String(plan.id)===this.plan))return;
    const eligible=this.eligibleLabels(plans,config.sellingPlanConfigs);
    if(!eligible.size)return;
    const nativeNames=plans.map(plan=>String(plan.name).trim()).sort();
    block.querySelectorAll('.kaching-subscriptions__dropdown-menu[role="listbox"]').forEach(menu=>{
      const options=Array.from(menu.querySelectorAll('button.kaching-subscriptions__dropdown-item[role="option"]'));
      const label=node=>node.querySelector('.kaching-subscriptions__dropdown-item-label')?.textContent.trim()||'';
      // Refuse ambiguous/stale variant menus or new app markup.
      if(options.length>20||this.canonical(options.map(label).sort())!==this.canonical(nativeNames))return;
      eligible.forEach((count,name)=>{
        const duplicates=options.filter(node=>label(node)===name);
        if(duplicates.length!==count||duplicates.some(node=>node.disabled||node.hidden||node.getAttribute('aria-disabled')==='true'))return;
        const selected=duplicates.filter(node=>node.getAttribute('aria-selected')==='true');
        if(selected.length>1)return;
        const keep=selected[0]||duplicates.find(node=>node===document.activeElement)||duplicates[0];
        duplicates.filter(node=>node!==keep).forEach(node=>{
          if(node===document.activeElement)keep.focus({preventScroll:true});
          this.hiddenChoices.set(node,{hidden:node.hidden,tabindex:node.getAttribute('tabindex'),ariaHidden:node.getAttribute('aria-hidden')});
          node.hidden=true;node.setAttribute('tabindex','-1');node.setAttribute('aria-hidden','true');node.setAttribute('data-ark-c6-hidden','');
        });
      });
    });
  }
  navigateChoices(event){
    if(!['ArrowDown','ArrowUp','Home','End'].includes(event.key))return;
    const trigger=event.target.closest?.('.kaching-subscriptions__dropdown-trigger-wrapper[aria-expanded="true"]');
    const menu=event.target.closest?.('.kaching-subscriptions__dropdown-menu[role="listbox"]')||trigger?.closest('.kaching-subscriptions__dropdown')?.querySelector('.kaching-subscriptions__dropdown-menu[role="listbox"]');
    if(!menu||!this.root.contains(menu)||!menu.querySelector('[data-ark-c6-hidden]'))return;
    const buttons=Array.from(menu.querySelectorAll('button.kaching-subscriptions__dropdown-item[role="option"]')).filter(node=>!node.hidden&&!node.hasAttribute('data-ark-c6-hidden')&&!node.disabled);
    if(!buttons.length)return;
    const current=buttons.indexOf(document.activeElement);
    const index=event.key==='Home'?0:event.key==='End'?buttons.length-1:event.key==='ArrowDown'?(current+1)%buttons.length:current<0?buttons.length-1:(current+buttons.length-1)%buttons.length;
    event.preventDefault();event.stopImmediatePropagation();buttons[index].focus();
  }
  displayPlans(plans){
    // Double Pack's two overlapping Kaching groups were policy-audited on
    // 2026-10-30. Only these two verified pairs may share a visible choice.
    // Keep the selected native ID; never submit a made-up or cross-variant ID.
    if(String(this.variant.id)!=='54340887347544')return plans;
    const auditedWeeks={'693238137176':8,'693238202712':8,'693238169944':4,'693238235480':4};
    const canonical=value=>Array.isArray(value)?value.map(canonical):value&&typeof value==='object'?Object.fromEntries(Object.keys(value).sort().map(key=>[key,canonical(value[key])])):value;
    const stable=value=>JSON.stringify(canonical(value));
    const keyFor=plan=>{
      const weeks=auditedWeeks[String(plan.id)],terms=plan.terms;
      if(!weeks||!terms||!Array.isArray(plan.options)||plan.options.length!==2||
          !Array.isArray(terms.adjustments)||!Array.isArray(terms.allocationAdjustments)||
          terms.recurring!==true||!Number.isFinite(plan.price)||
          !['description','checkoutCharge','compare','perDelivery','checkoutAmount','remainingBalance'].every(key=>Object.prototype.hasOwnProperty.call(terms,key)))return null;
      const policyOptions=plan.options.filter(value=>String(value)!==String(plan.id));
      if(policyOptions.length!==1)return null;
      let policy;try{policy=JSON.parse(policyOptions[0]);}catch{return null;}
      const expected={delivery:{interval:'WEEK',frequency:weeks},billing:{interval:'WEEK',frequency:weeks,minCycles:null,maxCycles:null},discount:{type:'PERCENTAGE',adjustmentValue:10},position:weeks===8?0:1};
      // Unknown or changed policy options fail open: show both native choices.
      if(stable(policy)!==stable(expected))return null;
      return stable([weeks,plan.name,plan.price,terms]);
    };
    const choices=[],groups=new Map();
    plans.forEach(plan=>{
      const key=keyFor(plan);
      if(key===null||!groups.has(key)){
        if(key!==null)groups.set(key,choices.length);
        choices.push(plan);
      }else if(String(plan.id)===String(this.plan))choices[groups.get(key)]=plan;
    });
    return choices;
  }

});
